import { heroData } from "../features/hero/data/heroData";
import { designSectionData } from "@/features/design/data/designData";
import { featuresData } from "../features/features-section/data/featuresData";
import { mobileAppData } from "../features/mobile-app/data/mobileAppData";
import { reviewsData } from "../features/reviews/data/reviewsData";
import { contactData } from "@/features/contact/data/contactData";
import { faqData } from "@/features/faq/data/faqData";

export const tempSiteData = {
  hero: heroData,
  design: designSectionData,
  features: featuresData,
  mobileApp: mobileAppData,
  reviews: reviewsData,
  contact: contactData,
  faq: faqData,
};
